var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreenshareToggled = function SvgScreenshareToggled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 28 22",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#screenshare-toggled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.359A4.359 4.359 0 0 1 4.359 0H23.64A4.359 4.359 0 0 1 28 4.359V17.64A4.359 4.359 0 0 1 23.641 22H4.36A4.359 4.359 0 0 1 0 17.641V4.36Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.38 7.706a.833.833 0 1 0-1.178-1.179L14 9.73l-3.202-3.203a.833.833 0 0 0-1.179 1.179l3.203 3.202-3.203 3.203a.833.833 0 1 0 1.179 1.178L14 12.087l3.202 3.202a.833.833 0 1 0 1.179-1.178l-3.203-3.203 3.203-3.202Z",
    fill: "#04A45A",
    stroke: "#04A45A",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "screenshare-toggled_svg__a",
    x: -10.897,
    y: -10.897,
    width: 49.795,
    height: 43.795,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 5.449
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5141_60"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_5141_60",
    result: "shape"
  })))));
};
export default SvgScreenshareToggled;